import { Chatroom } from '../../models';
import axios from 'axios';
import { constants } from '../../constants';

export const postTask = (room: Chatroom) => {
  const token = localStorage.getItem('token');
  return axios.post<void>(
    `${constants.endpoint}/users/daily-task`,
    {
      chatroomId: room.id,
    },
    {
      headers: {
        Authorization: `bearer ${token}`,
      },
    }
  );
};
